import React, { Component, useState, Fragment } from "react";
import { Accordion, Card } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import { CurrencyUtils } from "../../utils";

function CustomToggle({ init, children, eventKey }) {
  const decoratedOnClick = useAccordionToggle(eventKey);
  const [toggle, setToggle] = useState(false);

  const onToggle = e => {
    e.stopPropagation();
    setToggle(!toggle);
    decoratedOnClick();
  };

  return (
    <button
      className="btn btn-seconday m-auto d-flex"
      onClick={e => onToggle(e)}
    >
      รายละเอียด
      <img
        src={toggle ? SpanMoreTabTop : SpanMoreTabDown}
        width="20px"
        height="20px"
        alt="span image"
      />
    </button>
  );
}

export default class WidgetSummary extends Component {
  render() {
    const { planDetail, usertype = 1 } = this.props;
    const { insured, price, stamp, vat, total } = planDetail;
    return (
      <Accordion className="accordion-widget-wrapper">
        <Accordion.Collapse eventKey="1">
          <Fragment>
            <HR />
            <PlanDetail
              detail="เบี้ยประกันภัยสุทธิ"
              price={CurrencyUtils.currency(price)}
              userType={usertype}
            />
            <PlanDetail
              detail="ภาษีมูลค่าเพิ่ม"
              price={CurrencyUtils.currency(stamp)}
              userType={usertype}
            />
            <PlanDetail
              detail="อากรแสตมป์"
              price={CurrencyUtils.currency(vat)}
              userType={usertype}
            />
            <PlanDetail
              detail="เบี้ยประกันภัย"
              price={CurrencyUtils.currency(total)}
              userType={usertype}
            />
          </Fragment>
        </Accordion.Collapse>
        <CustomToggle eventKey="1" />
      </Accordion>
    );
  }
}

const HR = () => {
  const styles = {
    marginTop: "0px",
    marginBottom: "14px"
  };
  return <hr style={styles} />;
};

const PlanDetail = ({ className = "", detail, price, isBold, userType = 1 }) => { 
  const priceText = isBold ? <b>{price} บาท</b> : `${price} บาท`;
  return (
    <div className={`d-flex detail ${className}`}>
      <span style={{ marginBottom: "11px" }}>{detail}{userType == 1 && 'ต่อ 1 ท่าน'}</span>
      <span className="ml-auto price text-dark-blue font-bold">
        {priceText}
      </span>
    </div>
  );
};
